import React from 'react'
import SignatureCanvas from 'react-signature-canvas'
import ContainerDimensions from 'react-container-dimensions'
import { Wrapper, ClearBtn } from './Styles';

const SigPad = React.forwardRef(({ canvasProps, allowClear, onCleared, ...rest }, ref) => {
  return (
    <Wrapper>
      <ContainerDimensions>
        { ({ width }) => (
            <SignatureCanvas
              ref={ref}
              canvasProps={{
                width,
                height: 200,
                className: 'sigCanvas'
              }}
              {...rest}
            />
          )
        }
      </ContainerDimensions>
      {
        allowClear && ref && ref.current && (
          <ClearBtn
            type='button'
            onClick={() => {
            ref.current.clear()
            onCleared()
            }}
          >
          Clear
          </ClearBtn>
        )
      }
    </Wrapper>
  )
})

SigPad.defaultProps = {}

SigPad.propTypes = {}

export default SigPad


// WEBPACK FOOTER //
// ./src/Components/SigPad/SigPad.jsx